export default __webpack_public_path__ + "static/media/TerraExplorerPeru.8aca24af.jpg";